import apiClient from "./axios.config";

const bookService = {
  submitServicesForm(payload) {
    return apiClient.post("/owners/booking/create", payload);
  },
};

export default bookService;
